export const getCifUrl = (): string => process.env.REACT_APP_MSDYN_CIF_LIB_URL ?? '';
export const getCcpUrl = () => process.env.REACT_APP_CCP_URL ?? '';
export const getAppLoginUrl = () => process.env.REACT_APP_LOGIN_URL ?? '';
